import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { getCareerId } from '@/api/careerIdEndpoint';

type CareerIdState = {
    careerId?: number | null;
    loading: boolean;
    pendingPromise: Promise<any> | null;
};

const careerIdModule: Module<CareerIdState, RootState> = {
    namespaced: true,
    state: {
        careerId: null,
        loading: false,
        pendingPromise: null
    },
    getters: {
        careerId(state) {
            return state.careerId;
        },
        isLoading(state) {
            return state.loading;
        }
    },

    mutations: {
        set(state, value: CareerIdState) {
            Object.assign(state, value);
        },
        setLoading(state, loading: boolean) {
            state.loading = loading;
        },
        setPendingPromise(state, promise: Promise<any> | null) {
            state.pendingPromise = promise;
        }
    },

    actions: {
        async receive({ commit, getters, state }) {
            // If we already have the data, return immediately
            if (getters.careerId) return;
            
            // If there's already a pending request, return the existing promise
            if (state.pendingPromise) {
                return state.pendingPromise;
            }
            
            // Create a new promise for the API call properly
            const promise = new Promise((resolve) => {
                commit('setLoading', true);
                
                getCareerId()
                    .then(careerId => {
                        commit('set', careerId);
                        resolve(careerId);
                    })
                    .catch(error => {
                        console.error('Error fetching careerId:', error);
                        resolve(null); // Resolve with null in case of error
                    })
                    .finally(() => {
                        commit('setLoading', false);
                        commit('setPendingPromise', null);
                    });
            });
            
            // Store the promise in state so other calls can reuse it
            commit('setPendingPromise', promise);
            return promise;
        },
        clear({ commit }) {
            commit('set', {careerId: null});
            commit('setLoading', false);
            commit('setPendingPromise', null);
        }
    },
};

export default careerIdModule;